import initWasm, { Ledger } from '../wasm/phangan_engine_wasm.js';

export type SegmentOrigin = 'seed' | 'override';
export type ProgramMode = 'seeded_shuffle' | 'ordered_queue';

export interface OverrideConfig {
  slotIndex: number;
  op: 'set' | 'insert' | 'remove' | 'pin';
  trackId: number;
  createdAt: number;
  order: number;
}

export interface ProgramConfig {
  epochMs: number;
  seed: string; // u64 строкой
  mode: ProgramMode;
  pool: number[]; // track ids (индексы пула)
  queue?: number[];
  gapMs: number;
  overrides?: OverrideConfig[];
}

export interface PlacedTrack {
  slotIndex: number;
  trackId: number;
  startsAt: number;
  endsAt: number;
  durationMs: number;
  origin: SegmentOrigin;
}

let ready: Promise<void> | null = null;

/** Инициализировать WASM-движок (идемпотентно). */
export function initEngine(): Promise<void> {
  if (!ready) ready = initWasm().then(() => undefined);
  return ready;
}

/**
 * Тонкая TS-обёртка над Rust/WASM-лентой. Тот же код, что нативно на бэкенде —
 * расхождений нет (см. golden-vector в crates/engine).
 */
export class TimelineLedger {
  private inner: Ledger;

  constructor(cfg: ProgramConfig, durationsMs: number[]) {
    this.inner = new Ledger(cfg, new Float64Array(durationsMs));
  }

  placeWindow(from: number, to: number): PlacedTrack[] {
    return this.inner.placeWindow(from, to) as PlacedTrack[];
  }

  /** Live-слот эфира в момент `now` (epoch ms) или null (до старта станции). */
  slotAtTime(now: number): PlacedTrack | null {
    return this.inner.slotAtTime(now) as PlacedTrack | null;
  }

  trackAtSlot(idx: number): number {
    return this.inner.trackAtSlot(idx);
  }

  free(): void {
    this.inner.free();
  }
}
